export const depotsDropdownMapper = (data) =>
  data
    .map(({ depotCode, depotName, depotDescription }) => ({
      value: depotCode,
      label: `${depotName ? `${depotName} - ` : ""}${depotCode} ${
        depotDescription ? `(${depotDescription})` : ""
      }`,
    }))
    .sort((a, b) => (a.label > b.label ? 1 : -1));

export const selectedDepotDowngradesProps = (depots, selectedDepot) => {
  const depot = depots.find((depot) => depot.depotCode === selectedDepot);
  return {
    downgradeCutOff: depot?.downgradeCutOff,
    routePlannerDowngrades: depot?.routePlannerDowngrades,
  };
};
